import { authedApiFetch } from 'utils/Api';

const guardrailsService = {
	getGuardrails: async (tenantId) => {
		return await authedApiFetch({
			endpoint: `/tenants/${tenantId}/guardrails`,
			method: 'GET',
		});
	},

	updateGuardrails: async (tenantId, guardrails) => {
		return await authedApiFetch({
			endpoint: `/tenants/${tenantId}/guardrails`,
			method: 'PATCH',
			payload: {
				guardrails,
			},
		});
	},
};

export default guardrailsService;
